// extracted by mini-css-extract-plugin
export var admonition = "FeedbackWidget-module--admonition--14dbb";
export var successText = "FeedbackWidget-module--successText--998b4";
export var wrap = "FeedbackWidget-module--wrap--e8863";